export enum FollowupAction {
    POSTPONE = "POSTPONE",
    REMOVE = "REMOVE",
    DONE = "DONE",
}